// extracted by mini-css-extract-plugin
export default {"root":"_1aktV","dd":"_2jCyD","status-indicators":"Zwwsh","statusIndicators":"Zwwsh"};